<template>
  <a-modal
    :visible="visible"
    title="地区选择"
    @cancel="handleCancel"
    width="850px"
  >
    <div class="selected">
      <span>当前地区</span>
      <div v-if="selectedArea.name">{{ selectedArea.name || '' }}</div>
    </div>
    <div class="changed">
      切换到以下地区
    </div>
    <div style="margin-bottom: 15px;">
      <span style="">已选择：</span>
      <span v-for="(item, index) in crumbArray" :key="index">
        <span :style="index !== (crumbArray.length - 1) ? 'margin-left: 5px;color: #999' : 'margin-left: 5px;color: #333'">{{ item }}</span>
        <span style="margin: 0px 3px;" v-if="index !== (crumbArray.length - 1)">
          /
        </span>
      </span>
    </div>
    <div>
      <span style="color: #999;">省级行政区</span>
      <a-spin :spinning="provinceLoading">
        <div class="liContent" v-if="firstAreaArray && firstAreaArray.length > 0">
          <span :class="['liContentTag',item.isActive?'active':'']" v-for="(item) in firstAreaArray" :key="item.iid">
            <span @click="selectArea(item, 'type1')">
              <div style="display:inline-block;">{{ item.name }}</div>
            </span>
          </span>
        </div>
        <div v-else>
          <a-empty />
        </div>
      </a-spin>
    </div>
    <div v-if="crumbArray && crumbArray.length > 0">
      <span style="color: #999;">地级行政区</span>
      <a-spin :spinning="otherLoading">
        <div class="liContent" v-if="secondAreaArray && secondAreaArray.length > 0">
          <span :class="['liContentTag',item.isActive?'active':'']" v-for="(item) in secondAreaArray" :key="item.iid">
            <span @click="selectArea(item, 'type2')">
              <div style="display:inline-block;">{{ item.name }}</div>
            </span>
          </span>
        </div>
        <div v-else>
          <a-empty />
        </div>
      </a-spin>
    </div>
    <div v-if="crumbArray && crumbArray.length > 1">
      <span style="color: #999;">县级行政区</span>
      <a-spin :spinning="otherLoading1">
        <div class="liContent" v-if="thirdAreaArray && thirdAreaArray.length > 0">
          <span :class="['liContentTag',item.isActive?'active':'']" v-for="(item) in thirdAreaArray" :key="item.iid">
            <span @click="selectArea(item, 'type3')">
              <div style="display:inline-block;">{{ item.name }}</div>
            </span>
          </span>
        </div>
        <div v-else>
          <a-empty />
        </div>
      </a-spin>
    </div>
    <div v-if="crumbArray && crumbArray.length > 2">
      <span style="color: #999;">乡级行政区</span>
      <a-spin :spinning="otherLoading2">
        <div class="liContent" v-if="fourthAreaArray && fourthAreaArray.length > 0">
          <span :class="['liContentTag',item.isActive?'active':'']" v-for="(item) in fourthAreaArray" :key="item.iid">
            <span @click="selectArea(item, 'type4')">
              <div style="display:inline-block;">{{ item.name }}</div>
            </span>
          </span>
        </div>
        <div v-else>
          <a-empty />
        </div>
      </a-spin>
    </div>
    <template #footer>
      <div style="text-align:left;float: left;color:#FAAD14" v-show="!hasSame">
        <a-icon type="exclamation-circle" />
        所选地区无此事项</div>
      <a-button type="back" @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk">确定</a-button>
    </template>
  </a-modal>
</template>
<script>
import { jiopAPI } from '@/api/jiopweb/jiop.js'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb.js'

export default {
  name: 'AreaModal',
  components: {

  },
  data () {
    return {
      visible: false,
      selectedArea: {},
      crumbArray: [],
      selectArray: [],
      firstAreaArray: [],
      secondAreaArray: [],
      thirdAreaArray: [],
      fourthAreaArray: [],
      provinceLoading: false,
      otherLoading: false,
      otherLoading1: false,
      otherLoading2: false,
      hasSame: true
    }
  },
  methods: {
    open () {
      this.visible = true
      this.initData()
    },
    handleOk () {
      if (!this.selectedArea.name) {
        this.$message.warning('请选择区划！')
        return false
      } else {
        if (this.$route.name === 'oneThingGuide') {
          this.$emit('changeSameName', this.selectedArea.iid, this.selectedArea.name, JSON.stringify(this.selectArray))
        } else if (this.$route.name === 'GuideSimple') {
          this.$emit('changeSameNameSingle', this.selectedArea.iid, this.selectedArea.name, 'simple', JSON.stringify(this.selectArray))
        } else if (this.$route.name === 'GuideComplex') {
          this.$emit('changeSameNameSingle', this.selectedArea.iid, this.selectedArea.name, 'detail', JSON.stringify(this.selectArray))
        } else {
          this.$emit('ok', this.selectedArea.iid, [this.selectedArea.name], this.selectedArea.codeId)
          sessionStorage.setItem('JIOP_AREA', JSON.stringify(this.selectArray))
          this.handleCancel()
        }
      }
    },
    handleCancel () {
      this.visible = false
      this.selectedArea = {}
      this.crumbArray = []
      this.selectArray = []
      this.firstAreaArray = []
      this.secondAreaArray = []
      this.thirdAreaArray = []
      this.fourthAreaArray = []
      this.provinceLoading = false
      this.otherLoading = false
      this.otherLoading1 = false
      this.otherLoading2 = false
    },
    initData () {
      const that = this
      this.provinceLoading = true
      jiopWebAPI.districtList({ districtId: '0' }).then(res => {
        if (res.success) {
          that.provinceLoading = false
          const treeData = res.data.districtList ? res.data.districtList.map(item => {
            item.id = item.iid
            item.pId = item.pid
            item.value = item.iid
            item.title = item.name
            item.isLeaf = !item.hasChild
            return item
          }) : []
          that.firstAreaArray = treeData // 省级行政区数组
          if (!sessionStorage.getItem('JIOP_AREA')) {
            that.crumbArray = that.firstAreaArray.length > 0 ? [that.firstAreaArray[0].name] : [] // 面包屑的数组
            that.firstAreaArray[0].isActive = true
            that.selectArray = that.firstAreaArray.length > 0 ? [
              {
                iid: that.firstAreaArray[0].iid,
                name: that.firstAreaArray[0].name
              }
            ] : [] // 已选择的行政区数组
            that.selectedArea = that.firstAreaArray.length > 0 ? { name: that.firstAreaArray[0].name, iid: that.firstAreaArray[0].iid } : '' // 当前地区
            if (res.data.districtList && res.data.districtList.length > 0) {
              that.getNextArea(res.data.districtList[0].iid, 0)
            }
          } else {
            that.crumbArray = []
            const jsonArray = JSON.parse(sessionStorage.getItem('JIOP_AREA'))
            jsonArray.forEach(item => {
              that.crumbArray.push(item.name)
            })
            that.selectArray = jsonArray
            that.firstAreaArray.forEach(ele => {
              if (ele.iid === that.selectArray[0].iid) {
                ele.isActive = true
              }
            })
            const length = that.selectArray.length
            that.selectedArea = { iid: that.selectArray[length - 1].iid, name: that.selectArray[length - 1].name }
            that.circleArea()
          }
        }
      })
    },
    // 循环获取已选中的区划
    circleArea () {
      this.selectArray.forEach((item, index) => {
        if (index !== 3) {
          this.getNextArea(item.iid, index, 'select')
        }
      })
    },
    getNextArea (iid, type, flag) {
      const that = this
      if (type === 0) {
        this.otherLoading = true
        that.secondAreaArray = []
      } else if (type === 1) {
        this.otherLoading1 = true
        that.thirdAreaArray = []
      } else if (type === 2) {
        this.otherLoading2 = true
        that.fourthAreaArray = []
      }
      jiopWebAPI.districtList({ districtId: iid }).then(res => {
        if (res.success) {
          const tree = res.data.districtList ? res.data.districtList.map(item => {
            item.id = item.iid
            item.pId = item.pid
            item.value = item.iid
            item.title = item.name
            item.isLeaf = !item.hasChild
            return item
          }) : []
          if (type === 0) {
            that.secondAreaArray = tree
            that.otherLoading = false
            if (flag === 'select' && that.selectArray.length > 1) {
              that.secondAreaArray.forEach(ele => {
                if (ele.iid === that.selectArray[1].iid) {
                  ele.isActive = true
                }
              })
            }
          } else if (type === 1) {
            that.thirdAreaArray = tree
            that.otherLoading1 = false
            if (flag === 'select' && that.selectArray.length > 2) {
              that.thirdAreaArray.forEach(ele => {
                if (ele.iid === that.selectArray[2].iid) {
                  ele.isActive = true
                }
              })
            }
          } else if (type === 2) {
            that.fourthAreaArray = tree
            that.otherLoading2 = false
            if (flag === 'select' && that.selectArray.length > 3) {
              that.fourthAreaArray.forEach(ele => {
                if (ele.iid === that.selectArray[3].iid) {
                  ele.isActive = true
                }
              })
            }
          }
        }
      })
    },
    selectArea (item, flag) {
      if (flag === 'type1') {
        if (this.selectArray.length > 0 && this.selectArray[0].iid === item.iid) { // 代表省级区划已被选中，当前操作取消选中
          item.isActive = false
          this.crumbArray = []
          this.selectArray = []
          this.selectedArea = {}
        } else if (this.selectArray.length === 0) { // 省级区划未被选中
          item.isActive = true
          this.crumbArray = [item.name]
          this.selectArray = [
            {
              iid: item.iid,
              name: item.name
            }
          ]
          this.selectedArea = { iid: this.selectArray[0].iid, name: this.selectArray[0].name }
          this.getNextArea(item.iid, 0)
        } else { // 省级区划已被选中，切换区划
          this.firstAreaArray.forEach(ele => {
            if (ele.iid === this.selectArray[0].iid) {
              ele.isActive = false
            }
          })
          item.isActive = true
          this.crumbArray = [item.name]
          this.selectArray = [
            {
              iid: item.iid,
              name: item.name
            }
          ]
          this.selectedArea = { iid: this.selectArray[0].iid, name: this.selectArray[0].name }
          this.getNextArea(item.iid, 0)
        }
      } else if (flag === 'type2') {
        if (this.selectArray.length > 1 && this.selectArray[1].iid === item.iid) { // 代表地级区划已经被选中了，当前操作为取消选中
          item.isActive = false
          this.crumbArray.splice(1)
          this.selectArray.splice(1)
          this.selectedArea = { iid: this.selectArray[0].iid, name: this.selectArray[0].name } // 如果取消地级区划的选择，那么下面的区划也将被取消，只剩省级区划
        } else if (this.selectArray.length === 1) {
          item.isActive = true
          this.crumbArray.push(item.name)
          this.selectArray.push({ iid: item.iid, name: item.name })
          this.selectedArea = { iid: this.selectArray[1].iid, name: this.selectArray[1].name }
          this.getNextArea(item.iid, 1)
        } else { // 地级区划已被选中，切换区划
          console.log('====', this.selectArray, this.crumbArray)
          this.secondAreaArray.forEach(ele => {
            if (ele.iid === this.selectArray[1].iid) {
              ele.isActive = false
            }
          })
          item.isActive = true
          this.crumbArray.splice(1)
          this.selectArray.splice(1) // 清除下标从1开始的内容
          this.crumbArray.push(item.name)
          this.selectArray.push({ iid: item.iid, name: item.name })
          this.selectedArea = { iid: this.selectArray[1].iid, name: this.selectArray[1].name }
          console.log('====after====', this.crumbArray, this.selectArray)
          this.getNextArea(item.iid, 1)
        }
      } else if (flag === 'type3') {
        if (this.selectArray.length > 2 && this.selectArray[2].iid === item.iid) { // 代表县级区划已经被选中了，当前操作为取消选中
          item.isActive = false
          this.crumbArray.splice(2)
          this.selectArray.splice(2)
          this.selectedArea = { iid: this.selectArray[1].iid, name: this.selectArray[1].name } // 如果取消县级区划的选择，那么下面的区划也将被取消，只剩省级和地级区划
        } else if (this.selectArray.length === 2) { // 县级区划未被选中
          item.isActive = true
          this.crumbArray.push(item.name)
          this.selectArray.push({ iid: item.iid, name: item.name })
          this.selectedArea = { iid: this.selectArray[2].iid, name: this.selectArray[2].name }
          this.getNextArea(item.iid, 2)
        } else { // 县级区划已被选中，切换选中区划
          console.log('====', this.selectArray, this.crumbArray)
          this.thirdAreaArray.forEach(ele => {
            if (ele.iid === this.selectArray[2].iid) {
              ele.isActive = false
            }
          })
          item.isActive = true
          this.crumbArray.splice(2, 1, item.name)
          this.selectArray.splice(2, 1, {
            iid: item.iid,
            name: item.name
          })
          this.selectedArea = { iid: this.selectArray[2].iid, name: this.selectArray[2].name }
          console.log('====after====', this.crumbArray, this.selectArray)
          this.getNextArea(item.iid, 2)
        }
      } else {
        if (this.selectArray.length > 3 && this.selectArray[3].iid === item.iid) { // 代表乡级区划已经被选中了，当前操作为取消选中
          item.isActive = false
          this.crumbArray.splice(3)
          this.selectArray.splice(3)
          this.selectedArea = { iid: this.selectArray[2].iid, name: this.selectArray[2].name } // 如果取消乡级区划的选择，那么下面的区划也将被取消，只剩省级地级和乡级区划
        } else if (this.selectArray.length === 3) { // 乡级区划未被选中
          item.isActive = true
          this.crumbArray.push(item.name)
          this.selectArray.push({ iid: item.iid, name: item.name })
          this.selectedArea = { iid: this.selectArray[3].iid, name: this.selectArray[3].name }
        } else { // 县级区划已被选中，切换选中区划
          console.log('====', this.selectArray, this.crumbArray)
          this.thirdAreaArray.forEach(ele => {
            if (ele.iid === this.selectArray[3].iid) {
              ele.isActive = false
            }
          })
          item.isActive = true
          this.crumbArray.splice(3, 1, item.name)
          this.selectArray.splice(3, 1, {
            iid: item.iid,
            name: item.name
          })
          this.selectedArea = { iid: this.selectArray[3].iid, name: this.selectArray[3].name }
          console.log('====after====', this.crumbArray, this.selectArray)
        }
      }
      // 校验是否存在同名事项
      const itemName = sessionStorage.getItem('matter_name')
      const that = this
      if (this.$route.name === 'oneThingGuide') {
        jiopAPI.sameOneThing({ districtId: this.selectedArea.iid, oneThingName: itemName }).then(res => {
          if (res.success) {
            if (!res.data.oneThingId) {
              that.hasSame = false
            } else {
              that.hasSame = true
            }
          }
        })
      } else if (this.$route.name === 'GuideSimple' || this.$route.name === 'GuideComplex') {
        // 单事项
        jiopAPI.sanmeMatter({ districtId: this.selectedArea.iid, oneThingName: itemName }).then(res => {
          if (res.success) {
            if (!res.data.itemIds) {
              that.hasSame = false
            } else {
              that.hasSame = true
            }
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.selected {
  padding: 0px 0px 24px 0px;
  border-bottom: 1px solid #f1f2f3;
  display: flex;
  align-items: center;
  span {
    font-size: 20px;
    color: #333;
  }
  div {
    margin-left: 15px;
    border: 1px solid #f1f2f3;
    padding: 4px 8px;
    border-radius: 4px;
    background-color: #f1f2f3;
    font-size: 16px;
  }
}
.liContent {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  .liContentTag {
    border: 1px solid #d9d9d9;
    text-align: center;
    display: inline-block;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 16px;
    margin-bottom: 16px;
    cursor: pointer;
    color: #666;
    font-size: 16px;
  }
}
.active {
  background: #E6F7FF;
  color: #1890ff !important;
  border-color: #1890ff !important;
}
.changed {
  font-size: 20px;
  color: #333;
  padding: 15px 0px;
}
/deep/ .ant-modal-body {
    padding: 24px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
    max-height: 650px;
    overflow: auto;
}
</style>
